import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Lightbox controller for full-size photo preview with keyboard navigation.
//
// Usage:
//   data-controller="lightbox"
//   data-lightbox-photos-value='[{"url":"...","filename":"...","filesize":"..."}]'
//
// Each thumbnail button needs:
//   data-action="lightbox#open"
//   data-lightbox-index="0"   (zero-based index into photos array)

export default class extends Controller {
  static targets = ["overlay", "image", "filename", "filesize", "counter", "prevBtn", "nextBtn"]
  static values = { photos: Array, currentIndex: { type: Number, default: 0 } }

  connect() {
    this.keyHandler = this.handleKey.bind(this)
    document.addEventListener("keydown", this.keyHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.keyHandler)
  }

  open(event) {
    const index = parseInt(event.currentTarget.dataset.lightboxIndex, 10) || 0
    this.currentIndexValue = index
    this.showPhoto(index)
    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  next() {
    if (this.photosValue.length <= 1) return
    this.currentIndexValue = (this.currentIndexValue + 1) % this.photosValue.length
    this.showPhoto(this.currentIndexValue)
  }

  prev() {
    if (this.photosValue.length <= 1) return
    this.currentIndexValue = (this.currentIndexValue - 1 + this.photosValue.length) % this.photosValue.length
    this.showPhoto(this.currentIndexValue)
  }

  overlayClick(event) {
    // Close only when clicking the dark backdrop (not the image or controls)
    if (event.target === this.overlayTarget) this.close()
  }

  handleKey(event) {
    if (this.overlayTarget.classList.contains("hidden")) return
    switch (event.key) {
      case "Escape":     this.close(); break
      case "ArrowRight": this.next();  break
      case "ArrowLeft":  this.prev();  break
    }
  }

  showPhoto(index) {
    const photo = this.photosValue[index]
    if (!photo) return

    this.imageTarget.src = photo.url
    this.imageTarget.alt = photo.filename

    if (this.hasFilenameTarget) this.filenameTarget.textContent = photo.filename
    if (this.hasFilesizeTarget)  this.filesizeTarget.textContent  = photo.filesize
    if (this.hasCounterTarget)   this.counterTarget.textContent   = `${index + 1} / ${this.photosValue.length}`
  }
}

